import {
  ACTIVE_POLICY_WORDING,
  TAKAFUL_CW_EN,
  TAKAFUL_CW_MY,
  TAKAFUL_PDS_EN,
  TAKAFUL_PDS_MY,
  PRODUCT_SLUG,
} from './constant';

export enum DocumentType {
  PDS = 'pds',
  CW = 'cw',
}

interface LocaleUrls {
  [key: string]: string;
}

interface DocumentUrls {
  [key: string]: LocaleUrls;
}

const URLS: { [key: string]: string | DocumentUrls } = {
  [PRODUCT_SLUG.MSIG_CONVENTIONAL]: ACTIVE_POLICY_WORDING,
  [PRODUCT_SLUG.ZURICH_TAKAFUL]: {
    [DocumentType.PDS]: {
      en: TAKAFUL_PDS_EN,
      eni: TAKAFUL_PDS_EN,
      my: TAKAFUL_PDS_MY,
      myi: TAKAFUL_PDS_MY,
    },
    [DocumentType.CW]: {
      en: TAKAFUL_CW_EN,
      eni: TAKAFUL_CW_EN,
      my: TAKAFUL_CW_MY,
      myi: TAKAFUL_CW_MY,
    },
  },
};

const getProductUrl = (insuranceType: PRODUCT_SLUG): string | DocumentUrls => {
  return URLS[insuranceType] || '';
};

export const resolveLinks = (
  locale: string,
  insuranceType: PRODUCT_SLUG,
  documentType: DocumentType
): string => {
  const productUrl = getProductUrl(insuranceType);

  if (typeof productUrl === 'string') {
    return productUrl;
  }

  return productUrl?.[documentType]?.[locale.toLowerCase()] || '';
};
